import { Broker } from "@habity/types";
import slugify from "slugify";
import { ROUTES } from "@habity/constants";

export const getBrokerSlug = (broiker: Broker) => {
  const { id, name } = broiker || {}; // municipalities, areas
  if (!id) return "";

  const nameText = name ? slugify(name, { lower: true }) : "";

  return `${nameText}-${id}`;
};

export const getBrokerPath = (broker: Broker) => {
  return ROUTES.PROFILES.BROKERS + getBrokerSlug(broker);
};
